module.exports = __webpack_public_path__ + "static/9-b8d9f770bc2f9ce12ad59aa9607f6ec8.png";